import React from 'react'
import { Transfer } from 'antd'


export class ItemsTransfer extends React.Component {
    state = {
      currentItems:  this.props.currentItems
    }
  
    handleChange = (nextTargetKeys, direction, moveKeys) => {
      if (!this.props.disabled) {
        this.setState({ currentItems: nextTargetKeys });
        if (this.props.onChange) {
          this.props.onChange(nextTargetKeys)
        }
      }
    }
  
    handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
      if (this.props.disabled) {
        this.setState({ selectedKeys: [] });
      }
      else {
        this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });
      }
    }
  
    shouldComponentUpdate(nextProps) {
      if (nextProps.selectedUser._embedded.code !== this.props.selectedUser._embedded.code) {
        this.setState ({
          currentItems:   nextProps.currentItems   })
          return false
      }
      return true
    }
  
    render() {
      return (
        <Transfer 
          showSearch = {true}
          style = {this.props.style}
          listStyle = {this.props.listStyle}
          dataSource={this.props.allItems}
          titles={['Available', 'Selected']}
          targetKeys={this.state.currentItems}
          selectedKey = {this.state.selectedKeys}
          onChange={this.handleChange}
          onSelectChange={this.handleSelectChange}
          render={item => item.title}
          disabled={this.props.disabled}
        />
      );
    }
  }


// WEBPACK FOOTER //
// ./src/components/ItemsTransfer/ItemsTransfer.jsx